import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es.array.push.js";
import { FloatingArrow, FloatingPortal, arrow, autoPlacement, autoUpdate, flip, offset as offsetMiddleware, shift, useFloating } from "@floating-ui/react";
import React, { useRef, useState } from "react";
import { useTombac } from "../../shared";
import { useOutsideClick } from "../../shared/useOutsideClick";
import { Text } from "../Typography";
import { StyledTooltip } from "./TooltipStyles";
export const Tooltip = _ref => {
  let {
    children,
    closeOnOutsideClick = true,
    content,
    isOpen: isOpenProp,
    offset: offsetProp = [0, 12],
    onClose,
    onOpen,
    onOpenChange,
    placement = "auto",
    size = "m",
    usePortal = false,
    variant = "default",
    ...rest
  } = _ref;
  const tombac = useTombac();
  const isControlled = typeof isOpenProp === "boolean";
  const [isOpenState, setIsOpen] = useState(false);
  const isOpen = isControlled ? isOpenProp : isOpenState;
  const arrowRef = useRef(null);
  const arrowHeight = 5;
  const arrowWidth = arrowHeight * 2;
  const arrowFill = variant === "danger" ? tombac.color("danger", 400) : variant === "inverted" ? tombac.color("neutral", 900) : tombac.color("neutral", 100);
  const middleware = [offsetMiddleware({
    crossAxis: offsetProp[0],
    mainAxis: offsetProp[1]
  })];
  if (placement === "auto") {
    middleware.push(autoPlacement());
  } else {
    middleware.push(flip());
  }
  middleware.push(shift({
    padding: 8
  }));
  middleware.push(arrow({
    element: arrowRef
  }));
  const handleOpenChange = (nextOpen, event, reason) => {
    setIsOpen(nextOpen);
    onOpenChange === null || onOpenChange === void 0 || onOpenChange(nextOpen, event, reason);
    if (!isControlled) {
      if (nextOpen) {
        onOpen === null || onOpen === void 0 || onOpen();
      } else {
        onClose === null || onClose === void 0 || onClose();
      }
    }
  };
  const {
    context,
    floatingStyles,
    refs
  } = useFloating({
    middleware,
    open: isOpen,
    onOpenChange: handleOpenChange,
    placement: placement !== "auto" ? placement : undefined,
    whileElementsMounted: autoUpdate
  });
  useOutsideClick(refs.floating.current, () => handleOpenChange(false), {
    enabled: closeOnOutsideClick,
    excluded: [refs.domReference.current]
  });
  const controlFns = {
    open: () => handleOpenChange(true),
    close: () => handleOpenChange(false),
    toggle: () => handleOpenChange(!isOpen)
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, children({
    ...controlFns,
    ref: refs.setReference
  }), isOpen && /*#__PURE__*/React.createElement(ConditionalPortal, {
    usePortal: usePortal
  }, /*#__PURE__*/React.createElement(StyledTooltip, _extends({
    ref: refs.setFloating,
    style: floatingStyles,
    variant,
    size
  }, rest), typeof content === "string" ?
  /*#__PURE__*/
  // Padding top applied to compensate Noway font offset.
  React.createElement(Text, {
    $color: "inherit",
    $pt: "0.2em"
  }, content) : typeof content === "function" ? content(controlFns) : content, /*#__PURE__*/React.createElement(FloatingArrow, {
    context: context,
    fill: arrowFill,
    height: arrowHeight,
    ref: arrowRef,
    width: arrowWidth
  }))));
};
const ConditionalPortal = _ref2 => {
  let {
    usePortal,
    children
  } = _ref2;
  return usePortal ? /*#__PURE__*/React.createElement(FloatingPortal, null, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=Tooltip.js.map